import { Navigation } from "@/components/Navigation";
import Hero from "@/components/Hero";
import { PlatformFeatures } from "@/components/PlatformFeatures";
import { LearningDashboardShowcase } from "@/components/LearningDashboardShowcase";
import FeaturedCourses from "@/components/FeaturedCourses";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { FounderShowcase } from "@/components/FounderShowcase";
import { SocialProof } from "@/components/SocialProof";
import { TrustIndicators } from "@/components/TrustIndicators";
import { Footer } from "@/components/Footer";
import { usePageLoadPerformance } from "@/hooks/usePerformanceMonitor";

const Index = () => {
  usePageLoadPerformance("HomePage");
  
  return (
    <div className="min-h-screen-dvh bg-background w-full max-w-full overflow-x-hidden">
      <Navigation />
      <Hero />
      <PlatformFeatures />
      <LearningDashboardShowcase />
      <FeaturedCourses />
      <WhyChooseUs />
      <FounderShowcase />
      <SocialProof />
      <TrustIndicators />
      <Footer />
    </div>
  );
};

export default Index;
